var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page__wrap"},[_c(_vm.mode,{tag:"component",on:{"toggleMode":_vm.toggleMode}}),(_vm.mode !== 'BecomeClient')?_c('div',{staticClass:"login-page__img"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }